import styled from 'styled-components'

import miazgaLogo from '../assets/REDESIGN_Assets/LoginScreen/miazga-logo.png'
import miazgaLogoLight from '../assets/REDESIGN_Assets/theme/miazga-light-logo.png'

const GenericLogo = styled.div`
  width: ${(props) => (props.width ? props.width : '300px')};
  height: ${(props) => (props.height ? props.height : '150px')};
  display: ${(props) => (props.display ? props.display : 'flex')};
  justify-content: ${(props) => (props.justify ? props.justify : 'center')};
  align-items: ${(props) => (props.align ? props.align : 'center')};
  background-image: url(${(props) =>
    props.theme && props.theme == 'light' ? miazgaLogoLight : miazgaLogo});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  position: ${(props) => (props.position ? props.position : 'relative')};
  top: ${(props) => (props.top ? props.top : 'unset')};
  left: ${(props) => (props.left ? props.left : 'unset')};
  right: ${(props) => (props.right ? props.right : 'unset')};
  bottom: ${(props) => (props.bottom ? props.bottom : 'unset')};
  margin: ${(props) => (props.margin ? props.margin : 'unset')};
  z-index: ${(props) => (props.zIndex ? props.zIndex : '1')};

  @media only screen and (max-width: 600px) {
    width: ${(props) => (props.width ? props.width : '220px;')};
    height: ${(props) => (props.height ? props.height : '100px;')};
  }

  &.wizzardo-logo {
    @media only screen and (max-width: 1100px) {
      display: none;
    }

    @media only screen and (max-height: 700px) {
      display: none;
    }
  }
`

export default GenericLogo
